import React from 'react';
import BackupIcon from '@mui/icons-material/Backup';

interface FileUploadProps {
    onFilesAccepted: (files: { id: number; file: File }[]) => void;
}

let fileIdCounter = 0;

class FileUpload extends React.Component<FileUploadProps> {
    state = {
        isDragging: false,
        errorMessage: '',
    };

    acceptedFileTypes = [
        'image/jpeg', 'image/jpg', 'image/png', 'image/heic',
        'application/pdf', 'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'video/3gp', 'video/3gpz', 'video/3gpp', 'video/mov', 'video/mp4', 'video/quicktime'
    ];
    maxFileSize = 5 * 1024 * 1024; // 5 MB in bytes

    inputRef = React.createRef<HTMLInputElement>();

    handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        console.log("Drag Over");
    };

    handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({ isDragging: false });
        console.log("Drop Event Triggered");

        const files = event.dataTransfer.files;
        this.processFiles(files);
    };

    handleDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({ isDragging: false });
        console.log("Drag Leave");
    };

    handleDragEnter = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({ isDragging: true });
        console.log("Drag Enter");
    };

    handleClick = () => {
        this.inputRef.current?.click();
    };

    handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        console.log("Files Selected:", files);
        this.processFiles(files);
    };

    processFiles(files: FileList | null) {
        if (files) {
            const validFiles = Array.from(files).filter(file =>
                this.acceptedFileTypes.includes(file.type) && file.size <= this.maxFileSize
            );

            if (validFiles.length > 0) {
                const fileArray = validFiles.map(file => ({
                    id: fileIdCounter++,
                    file,
                }));
                this.props.onFilesAccepted(fileArray);
                this.setState({ errorMessage: '' });
            } else {
                this.setState({ errorMessage: 'Please upload files of allowed types and size (max 5 MB) only.' });
            }
        }
    }

    render() {
        const { isDragging, errorMessage } = this.state;
        return (
            <div>
                <div
                    onDragOver={this.handleDragOver}
                    onDrop={this.handleDrop}
                    onDragLeave={this.handleDragLeave}
                    onClick={this.handleClick}
                    onDragEnter={this.handleDragEnter}
                    className={isDragging ? 'dragging' : ''}
                    style={{
                        margin: '20px',
                        border: '1.5px dashed black',
                        borderRadius: '5px',
                        padding: '20px',
                        textAlign: 'center',
                        height: 'auto',
                        cursor: isDragging ? 'copy' : 'pointer',
                        minHeight: '200px',
                        backgroundColor: 'antiquewhite',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <p><BackupIcon /></p>
                    <h5>Drop File(s) Here</h5>
                    <p>Image formats: .jpg, .jpeg, .png, .heic</p>
                    <p>Document formats: .doc, .docx, .pdf</p>
                    <p>Video formats: .3gP, .3gP2, .3gPP, .mov, .mp4</p>
                    <p>Max File Size: 5 MB</p>
                    <p>Drag 'n' drop files here, or click to select files</p>
                </div>
                {errorMessage && (
                    <p style={{ color: 'red', marginTop: '10px', marginLeft:'20px' }}>{errorMessage}</p>
                )}
                <input
                    ref={this.inputRef}
                    type="file"
                    multiple
                    onChange={this.handleFileChange}
                    style={{ display: 'none' }}
                />
            </div>
        );
    }
}

export default FileUpload;
